export default __webpack_public_path__ + "assets/31dcc70dd59df668cdf7f95f498ae8e5.png";